import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular';

export class CustomIonicReuseStrategy extends IonicRouteStrategy implements RouteReuseStrategy {
  // until we have a better fix to move off the <ion-router-outlet> leave this array blank, in future it should be used on es-admin ag grids
  private readonly alwaysReloadUrls = [];

  /**
   * IMPORTANT: This strategy will not work right now, because of <ion-router-outlet> overriding the behavior of any strategy.
   * Determines whether or not the given route should be reused.
   *
   * If the route is in the list of always reload URLs, then the route is not reused.
   * Otherwise, the route is reused if the default `IonicRouteStrategy` says it can be.
   *
   * @param future The route to check.
   * @param curr The current route.
   * @returns Whether or not the route should be reused.
   */
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // const futureUrl = future.routeConfig?.path;
    // if (this.alwaysReloadUrls.includes('/' + futureUrl)) {
    //   return false;
    // }
    return super.shouldReuseRoute(future, curr);
  }
}
